import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // ربط ملف الترجمة الذي أنشأناه سابقاً
// 🎯 الـ interceptors (التوكن المنتهي + ترجمة رسائل الخطأ) لازم تتسجل على axios من
// أول تشغيل، مش لما أول شاشة تستورد axiosConfig بالصدفة
import './components/axiosConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
